var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("fragment", [
    _c("div", { staticClass: "attachment_wrap" }, [
      _c("div", { attrs: { id: _vm.uploadId } })
    ]),
    _vm._v(" "),
    !_vm.buttonDisable
      ? _c("div", { staticClass: "btn_wrap pt-10" }, [
          _c("div", { staticClass: "btn_right" }, [
            !_vm.toolManager
              ? _c(
                  "a",
                  {
                    staticClass: "btn_sm_white",
                    attrs: { href: "javascript:", type: "button" },
                    on: {
                      click: function($event) {
                        return _vm.openFileDialog()
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("BUTTON.GLOBAL.PC")))]
                )
              : _vm._e(),
            _vm._v(" "),
            !_vm.toolManager
              ? _c(
                  "a",
                  {
                    staticClass: "btn_sm_white",
                    attrs: { href: "javascript:", type: "button" },
                    on: {
                      click: function($event) {
                        return _vm.removeSelectedFiles()
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("BUTTON.GLOBAL.DELETE.SELECTED")))]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "btn_sm_white",
                attrs: { href: "javascript:", type: "button" },
                on: {
                  click: function($event) {
                    return _vm.removeAllFiles()
                  }
                }
              },
              [_vm._v(_vm._s(_vm.$t("BUTTON.GLOBAL.DELETEALL")))]
            )
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1d490edc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d490edc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/skpComponents/common/InnorixUpload.vue
// module id = WTYu
// module chunks = 0